import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import handleOpenWhatsApp from 'services/whatsappService';

const AreYouReady = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box>
      <Box
        component={Typography}
        sx={{ fontWeight: 700 }}
        variant={'h2'}
        gutterBottom
        align={'center'}
        marginBottom={"2rem"}
      >
        ¿Listo para brindar con nuestra audiencia?
      </Box>
      <Box
        component={Typography}
        sx={{ fontWeight: 600 }}
        variant={'h4'}
        gutterBottom
        align={'center'}
        marginBottom={"2rem"}
        color="textSecondary"
      >
        Forma parte de 3 de Copas y conecta con quienes buscan conversación, estilo y transformación. Hagamos que tu marca sea parte del momento en que la audiencia se detiene a escuchar.
      </Box>

      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={12} md={10} lg={8}>
          <Box data-aos="fade-up" textAlign={{ xs: 'left', md: 'center' }}>
            <Box marginBottom={2}>
              <Typography
                variant="h5"
                color="textPrimary"
                sx={{
                  fontWeight: 700,
                }}
              >
                Menciones en vivo, segmentos temáticos y piezas UGC: tu marca con el mismo tono auténtico del programa.
              </Typography>
            </Box>
            <Box marginBottom={3}>
              <Typography
                variant="body1"
                component="p"
                color="textSecondary"
                sx={{ fontWeight: 400 }}
              >
                3 de Copas, con Zidney al frente. Contenido que conversa.
              </Typography>
            </Box>
            <Box
              display="flex"
              flexDirection={{ xs: 'column', sm: 'row' }}
              alignItems={{ xs: 'stretched', sm: 'center' }}
              justifyContent={{ xs: 'flex-start', md: 'center' }}
            >
              <Button
                component={'a'}
                variant="contained"
                color="primary"
                size="large"
                fullWidth={isMd ? false : true}
                onClick={handleOpenWhatsApp}
                target={'_blank'}
              >
                Patrocinar 3 de Copas
              </Button>
              <Box
                marginTop={{ xs: 2, sm: 0 }}
                marginLeft={{ sm: 2 }}
                width={{ xs: '100%', sm: 'auto' }}
              >
                <Button
                  component={'a'}
                  href={'https://www.tnonetwork.com'}
                  variant="outlined"
                  color="primary"
                  size="large"
                  fullWidth={isMd ? false : true}
                >
                  TNO Network
                </Button>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Box marginTop={4} textAlign="center">
        <Typography variant="body2" color="textSecondary">
          © TNO Network 2026 | 3 de Copas: conversación que conecta.
        </Typography>
      </Box>
    </Box>
  );
};

export default AreYouReady;
